<template>
  <div class="container-lg !pr-0 flex w-full">
    <div
        class="w-full lg:w-1/2 flex flex-col h-[730px] items-center justify-center px-[20px] sm:px-[20%] lg:px-[40px] xl:px-[82px] ">

      <div class="mb-[20px] text-center">
        <h1 class="section__title  section__title--lg">
          {{ splitTitle(in18['page_login'])?.first }}
          <span :class="['text-lime-green ']">
                {{ splitTitle(in18['page_login'])?.last }}
            </span>
        </h1>
        <div class="text-[16px] font-light text-medium-gray">
          {{ in18['page_welcome_back'] }}
        </div>
      </div>

      <div class="w-full">
        <form :action="login_route" class="flex flex-col gap-[12px]" method="POST">
          <slot name="captcha"></slot>
          <input :value="csrf" name="_token" type="hidden"/>

          <div class="flex flex-col gap-1 relative">
            <label :class="[login ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                   for="email">
              {{ in18['attribute_email'] }}
            </label>
            <input
                id="email"
                v-model="login"
                :class="[errors['email'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', login && 'pt-[30px]' ]"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="email"
                type="text"
                @input="clearValidationError('email')"
            >
            <span v-if="errors['email']?.length" class="!text-[12px] text-[#eb2635]">*{{ errors['email']?.[0] }}</span>
          </div>

          <div class="flex flex-col gap-1 relative">
            <label :class="[password ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                   class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                   for="password">
              {{ in18['attribute_password'] }}
            </label>
            <input
                id="password"
                v-model="password"
                :class="[errors['password'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', password && 'pt-[30px]' ]"
                :disabled="inProgress"
                class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                name="password"
                type="password"
                @input="clearValidationError('password')"
            >
            <span v-if="errors['password']?.length"
                  class="!text-[12px] text-[#eb2635]">*{{ errors['password']?.[0] }}</span>
            <span v-if="errors['g-recaptcha-response']?.length"
                  class="!text-[12px] text-[#eb2635]">*{{ errors['g-recaptcha-response']?.[0] }}</span>
          </div>
          <slot name="actions"/>

          <button class="btn  btn--green  btn--md  btn--block" type="submit">
            {{ in18['page_log_in'] }}
          </button>

          <div class="text-center text-[14px] ">
            {{ in18['page_dont_have_profile'] }}
            <a :href="register_route" class="link  link--primary font-medium"
               title="{{in18['page_register'] }}">
              <b>{{ in18['page_register'] }}</b>
            </a>
          </div>
        </form>
      </div>
    </div>
    <div class="hidden lg:block w-1/2">
      <img alt="background" class="object-cover object-left w-full h-full" src="/shop/images/login/auth_bg.webp">
    </div>
  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue'

const props = defineProps({
  in18:           {
    type:     Object,
    required: true
  },
  login_route:    {
    type:     String,
    required: true
  },
  register_route: {
    type:     String,
    required: true
  },
  csrf:           {
    type:     String,
    required: true
  },
  errors:         {
    type:     Object,
    required: true
  }
})

const login = ref(null)
const password = ref(null)
const inProgress = ref(false)

const clearValidationError = fieldName => {
  if (props.errors[fieldName]) {
    props.errors[fieldName] = null;
  }
  if (props.errors['g-recaptcha-response']) {
    props.errors['g-recaptcha-response'] = null;
  }
};

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};

</script>